<template>
  <div class="container mains">
    <div class="code-div">
      <!-- <img :src="zhifusrc" v-show="isLoaded"> -->
      <canvas id="msg"></canvas>
      <p>
        微信扫码支付后，请耐心等待（还剩
        <span class="red">{{60-t}} s</span>）
      </p>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { Loading } from "element-ui";
import { weixin, getorder } from "../api/order/order";
const formJson = {
  consignee: "",
  mobile: "",
  sheng: "",
  shi: "",
  qu: "",
  address: "",
  user_id: "",
  order_id: ""
};
var timerWx;
export default {
  name: "zhifu",
  data() {
    return {
      zhifusrc: "",
      order_id: "",
      order_sn: "",
      order_amount: "",
      isLoaded: false,
      t: 0
    };
  },
  beforeDestroy() {
    clearInterval(timerWx);
  },
  methods: {
    checkResult() {
      clearInterval(timerWx);
      var a = 1;
      this.t = 1;
      timerWx = setInterval(() => {
        a++;
        this.t++;
        if (a == 60) {
          setTimeout(() => {
            this.$router.replace("/myorder");
          }, 1000);
          clearInterval(timerWx);
        }
        getorder({
          order_id: this.$route.query.order_id,
          user_id: this.$cookies.get("uid")
        }).then(res => {
          if ((res.data.code == 0||res.data.code == 1) && res.data.data.order_status >= 1) {
            this.$message.success("支付成功");
            clearInterval(timerWx);
            setTimeout(() => {
              this.$router.replace("/myorder");
            }, 1000);
          }
        });
      }, 1000);
    },
    getorderrecord() {
      getorder({
        order_id: this.$route.query.order_id,
        user_id: this.$cookies.get("uid")
      }).then(response => {
        if (response.data.code == 1) {
          let param = {
            order_id: this.$route.query.order_id,
            order_sn: response.data.data.order_number,
            order_amount: response.data.data.amount,
            order_xuzu: this.$route.query.order_xuzu
          };
          weixin(param)
            .then(response => {
              if (response.data) {
                if(response.data.code&&response.data.code=='409'){
                  this.$router.push("/myorder");
                  this.$message.error(response.data.msg||response.data.message)
                  return
                }
                this.zhifusrc = response.data.url;
                var msg = document.getElementById("msg");
                var url=response.data.url.split('?text=')[1]
                QRCode.toCanvas(msg, url,res=>{
                  console.log(res)
                });
                this.checkResult();
              } else {
                this.zhifusrc = "";
                this.isLoaded = false;
              }
            })
            .catch(e => {
              this.zhifusrc = "";
              this.isLoaded = false;
            });
        } else {
          this.zhifusrc = "";
          this.isLoaded = false;
        }
      });
    },
    getorderinfo() {
      let param = {
        order_id: this.$route.query.order_id,
        order_sn: this.$route.query.order_sn,
        order_amount: this.$route.query.order_amount
      };
      weixin(param)
        .then(response => {
          if (response.data) {
            this.zhifusrc = response.data.url;
          } else {
            this.zhifusrc = "";
          }
        })
        .catch(e => {
          this.zhifusrc = "";
        });
    }
  },
  created() {
    this.getorderrecord();
  }
};
</script>

<style scoped>
.mains {
  position: relative;
}
.code-div {
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.code-div img {
  width: 200px;
  height: 200px;
}
.code-div p {
  width: 320px;
  text-align: center;
  color: #555;
  font-size: 16px;
}
.code-div p .red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/zhifu.vue